const defaultEmail =
    "<h2>Les avantages ?</h2><p><br>Cet espace vous appartient et vous facilitera notamment :</p><ul><li>l'Accès à vos titres et vos contrats</li><li>le Suivi des relevés de droits d'auteur et des paiements</li><li>la Gestion de vos informations personnelles</li><li>les Notifications informatives pour un meilleur suivi</li></ul>";

export default defaultEmail;
